import React from 'react'

import Box from '@mui/material/Box'

import {
  ANALYTICS_EVENTS,
  useAppConfig,
  useEvent,
  useGlobalCopyStore,
  useHelpStore,
  useScreenSize,
} from '../../common'
import { type SelectedTopic } from '../../core'

import { HelpList } from './HelpList'
import { HelpContent } from './HelpContent'
import { RequestSupport } from './requestsupport'
import type { SxProps } from '@mui/material/styles'

interface HelpProps {
  sx?: SxProps
}

export const Help = ({ sx = {} }: HelpProps) => {
  const { config } = useAppConfig()
  const { onEvent } = useEvent()
  const { help: helpCopy } = useGlobalCopyStore()
  const { helpCategories } = useHelpStore()
  const { isMobile } = useScreenSize()

  const [isRequestSupportOpen, setIsRequestSupportOpen] = React.useState(false)
  const [selectedTopic, setSelectedTopic] = React.useState<SelectedTopic | null>(null)

  const handleTopicSelect = (topic: SelectedTopic) => {
    onEvent(ANALYTICS_EVENTS.HELP_CLICK_TOPIC, {
      feature: topic.category,
      helpTopic: topic.pageTitle,
    })

    setSelectedTopic(topic)
  }
  const handleRequestHelp = () => setIsRequestSupportOpen(true)

  return (
    <Box sx={{ pt: 24, px: isMobile ? 24 : 0, ...sx }}>
      {!selectedTopic ? (
        <HelpList
          buttonText={helpCopy.request_support}
          hasRequestButton={config.enable_support_requests}
          helpCategories={helpCategories}
          helpContent={helpCopy.list_short_content}
          helpTitle={helpCopy.list_title}
          onRequestHelp={handleRequestHelp}
          onTopicSelect={handleTopicSelect}
        />
      ) : (
        <HelpContent
          copy={helpCopy}
          hasRequestButton={config.enable_support_requests}
          onNavigateToList={() => setSelectedTopic(null)}
          onRequestSupport={handleRequestHelp}
          topicInfo={selectedTopic}
        />
      )}
      <RequestSupport
        copy={helpCopy}
        isOpen={isRequestSupportOpen}
        onClose={() => setIsRequestSupportOpen(false)}
      />
    </Box>
  )
}
